export const TOGGLE_VIEW = 'config/TOGGLE_VIEW';
